var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1627 23.6883L44.1685 23.7584L44.1627 24.0447L44.1264 24.261L44.0821 24.4174L44.03 24.5529L43.9488 24.7161L43.8121 24.9216L43.6661 25.0875L34.4572 34.2963C33.7829 34.9706 32.6896 34.9706 32.0153 34.2963C31.4023 33.6833 31.3466 32.7241 31.8482 32.0481L32.0153 31.8545L38.2758 25.5932L5.60961 25.5932C4.73547 25.5932 4.01305 24.9436 3.89871 24.1008L3.88295 23.8665C3.88295 22.9924 4.53253 22.2699 5.37532 22.1556L5.60961 22.1399L38.2781 22.1399L32.0153 15.8786C31.4023 15.2656 31.3466 14.3063 31.8482 13.6304L32.0153 13.4367C32.6283 12.8237 33.5876 12.768 34.2636 13.2695L34.4572 13.4367L43.6661 22.6456L43.876 22.8995L44.0016 23.1179L44.0825 23.3171L44.1432 23.5527L44.1627 23.6883Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow-Right.f0603fa1a0400144b1403d54e7d3f60d.svg";
export { ForwardRef as ReactComponent };